<template>
  <div class="video-one-line-for-two"  :id="'fullParent'+componentIndex"  style="background-color: black;position: relative">
    <div class="covers"></div>
    <div style="height: 100%;display: flex" >
      <video
        :muted="voiceOff"
        :id="'myVideo'+componentIndex"
        :autoplay="true"
        loop
        :poster="dataSource+videoStr"
        :preload="preloadstr"
        x-webkit-airplay="true"
        playsinline="true"
        webkit-playsinline="true"
        class="video"
        :src="dataSource"
      >
      </video>
      <div v-if="useVideoController" class="bottom-control-bar-box" @click.stop>
      <div class="video-icon" @click.stop="playOrPauseClick('myVideo'+componentIndex)">
        <img v-if="playingVideo" src="../../../assets/image/icon/video_pause_icon.png" />
        <img v-if="!playingVideo" src="../../../assets/image/icon/video_play_icon.png" />
      </div>
      <div class="time-box">{{currentTimeString}}/{{totalTimeString}}</div>
      <div
        ref="time_line"
        class="time-line-box"
        @mousedown="seekStart"
        @mousemove="seekMove"
        @mouseup="seekEnd"
      >
        <div :style="{width:getPlayedWidth('time_line')+'px'}" class="time-line-played"></div>
        <div :style="{left:getPlayedWidth('time_line')+'px'}" class="seekingBox"></div>
        <div :style="{width: getNotPlayWidth('time_line')+'px'}" class="time-line-not-played"></div>
      </div>
      <div class="video-icon" @click.stop="voiceOnOrOff">
        <img v-if="voiceOff" src="../../../assets/image/icon/video_voice_off.png" />
        <img v-if="!voiceOff" src="../../../assets/image/icon/video_voice_on.png" />
      </div>
      <div
        class="video-icon"
        style="margin-left: 1.5rem"
        @click.stop="fullScreenClick('fullParent'+componentIndex)"
      >
        <img src="../../../assets/image/icon/video_full_screen.png" />
      </div>
    </div>
      <!-- <div @click.stop>
        <div @click="voiceOff = !voiceOff" v-if="useVideoController" class="audio-icon-box">
          <img v-if="!voiceOff" src="../../../assets/image/icon/video_voice_on.png" />
          <img v-if="voiceOff" src="../../../assets/image/icon/video_voice_off.png" />
        </div>
      </div> -->

      <blinds v-if="useBYC"></blinds>
    </div>
  </div>
</template>

<script>
import Blinds from "./Blinds";
export default {
  name: "VideoOneLineForTwo",
  components: { Blinds },
  data() {
    return {
      videoStr: "?vframe/jpg/offset/2",
      preloadstr: "auto",
      voiceOff: true,
      playingVideo: true,
      voiceOff: true,
      currentTimeString: "00:00",
      currentTime: 0,
      totalTimeString: "00:00",
      totalTime: 0,
      timeLineClientX: 0,
      dragging: false,
      fullScreen: false,
      showBottomController: false
    };
  },
  watch: {
    dragging(newVal) {
      if (newVal) {
        this.playingVideo = false;
      } else {
        this.playingVideo = true;
      }
      const playerLive = document.getElementById(
        "myVideo" + this.componentIndex
      );
      if (this.playingVideo) {
        playerLive.play();
      } else {
        playerLive.pause();
      }
    }
  },
  props: {
    dataSource: {
      required: true,
      type: String
    },
    componentIndex: {
      type: Number,
      required: true
    },
    useVideoController: {
      required: true,
      default: false,
      type: Boolean
    },
    useBYC: {
      default: false,
      type: Boolean
    }
  },
 
  mounted() {
    this.$nextTick(() => {
      const playerLive = document.getElementById(
        "myVideo" + this.componentIndex
      );
      if (!playerLive) {
        return;
      }
      playerLive.addEventListener("loadedmetadata", () => {
        this.totalTime = playerLive.duration;
        this.totalTimeString = this.formatTime(playerLive.duration);
      });
      playerLive.addEventListener("timeupdate", () => {
        this.currentTime = playerLive.currentTime;
        this.currentTimeString = this.formatTime(playerLive.currentTime);
      });
      playerLive.addEventListener("play", () => {
        this.playingVideo = true;
      });
      playerLive.addEventListener("pause", () => {
        this.playingVideo = false;
      });
    });
  },
  methods: {
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    formatTime(value) {
      let result = parseInt(value);
      let h =
        Math.floor(result / 3600) < 10
          ? "0" + Math.floor(result / 3600)
          : Math.floor(result / 3600);
      let m =
        Math.floor((result / 60) % 60) < 10
          ? "0" + Math.floor((result / 60) % 60)
          : Math.floor((result / 60) % 60);
      let s =
        Math.floor(result % 60) < 10
          ? "0" + Math.floor(result % 60)
          : Math.floor(result % 60);
      result = `${h}:${m}:${s}`;
      return result;
    },
    fullScreenClick(key) {
      if (document.fullscreenElement) {
        this.fullScreen = true;
      } else {
        this.fullScreen = false;
      }
      let player = document.getElementById(key);
      let realPlayer = document.getElementById("myVideo" + this.componentIndex);
      if (this.fullScreen) {
        this.exitFullScreen();
        this.fullScreen = false;
      } else {
        this.fullScreen = true;
        const rfs =
          player.requestFullscreen ||
          player.webkitRequestFullScreen ||
          player.mozRequestFullScreen ||
          player.msRequestFullscreen;
        const realRfs =
          realPlayer.requestFullscreen ||
          realPlayer.webkitRequestFullScreen ||
          realPlayer.mozRequestFullScreen ||
          realPlayer.msRequestFullscreen;
        // realRfs.call(realPlayer);
        rfs.call(player);
      }
    },
    seekMove(event) {
      if (!this.dragging) {
        return;
      }
      let timeLineClientX = this.$refs.time_line.getBoundingClientRect().x;
      let position = event.clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      const playerLive = document.getElementById(
        "myVideo" + this.componentIndex
      );
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.time_line.clientWidth;
    },
    seekEnd(event) {
      this.dragging = false;
    },
    seekStart(event) {
      this.dragging = true;
      let timeLineClientX = this.$refs.time_line.getBoundingClientRect().x;
      let position = event.clientX - timeLineClientX;
      if (position < 0) {
        position = 0;
      }
      let playerLive = document.getElementById("myVideo" + this.componentIndex);
      playerLive.currentTime =
        (this.totalTime * position) / this.$refs.time_line.clientWidth;
    },
    playOrPauseClick(key) {
      const playerLive = document.getElementById(key);
      if (this.playingVideo) {
        playerLive.pause();
      } else {
        playerLive.play();
      }
    },
    voiceOnOrOff() {
      this.voiceOff = !this.voiceOff;
    },
    getPlayedWidth(key) {
      if (this.$refs[key]) {
        let width =
          this.$refs[key].clientWidth * (this.currentTime / this.totalTime);
        return width;
      }
      return 0;
    },
    getNotPlayWidth(key) {
      if (this.$refs[key]) {
        let width =
          this.$refs[key].clientWidth * (this.currentTime / this.totalTime);
        return this.$refs[key].clientWidth - width;
      }
      return 0;
    }
  }
};
</script>

<style scoped lang="less">
.video-one-line-for-two {
  width: 100%;
  // height: 100%;
  .video {
    width: 100%;
    min-height: 100%;
    height: auto;
    vertical-align: top;
    //position: absolute;
    //top: 50%;
    //left: 50%;
    //transform: translate(-50%, -50%);
    //-webkit-transform: translate(-50%, -50%);
  }
  .audio-icon-box {
    position: absolute;
    bottom: 2rem;
    right: 2rem;
    width: 3.4rem;
    height: 3.4rem;
    background-color: #2a2a2a;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    opacity: 0;
    cursor: pointer;
    z-index: 9;
    img {
      width: 2.5rem;
      height: 2.5rem;
    }
  }
}
.video-one-line-for-two:hover {
  // .audio-icon-box {
  //   transition: opacity 0.5s;
  //   opacity: 1 !important;
  // }
  .bottom-control-bar-box {
    transition: opacity 0.5s;
    opacity: 1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/customize/VideoOneLineForTwo.vue